import { Injectable } from '@angular/core';
import { Mesh, Vector3 } from 'babylonjs';
import { LayerUI, LayerUiExpandable } from '@App/app/entities/layer/layer-ui.model';
import { RectTubeData } from '@App/app/entities/layer/rect-tube.model';
import { ViewerSketchPlaneLayer } from '@App/app/entities/layer/sketch-tools/sketch-plane.model';
import { AnnotationPriorities } from '@App/app/entities/shared/annotation-priorities.enum';
import { AnnotationViewerLayer } from '../../../viewer-layers/annotation-viewer-layer';
import { CuboidViewerLayer } from '../../../viewer-layers/cuboid-viewer-layer';
import { PolygonViewerLayer } from '../../../viewer-layers/polygon-viewer-layer';
import { SketchLineViewerLayer } from '../../../viewer-layers/sketch-line-viewer-layer';
import { SketchPlaneViewerLayer } from '../../../viewer-layers/sketch-plane-viewer-layer';
import { ViewerLayerRegistryService } from './viewer-layer-registry.service';

@Injectable({
  providedIn: 'root',
})
export class ViewerLayerTypedOpsService {
  constructor(private registry: ViewerLayerRegistryService) {}

  updateAnnotationPriority(id: number, priority: AnnotationPriorities): void {
    (this.registry.getLayer(id) as AnnotationViewerLayer)?.setPriority(priority);
  }

  setTmpData(id: number, data: Partial<RectTubeData>): void {
    (this.registry.getLayer(id) as CuboidViewerLayer)?.setData(data);
  }

  addPointToPolygon(id: number, point: Vector3): void {
    (this.registry.getLayer(id) as PolygonViewerLayer)?.addPointToPolygon(point);
  }

  toggleChildLayerVisibility(parent: LayerUI | LayerUiExpandable, childId: number): void {
    (this.registry.getLayer(parent.id) as SketchPlaneViewerLayer)?.toggleChildVisibility(
      parent,
      childId,
    );
  }

  getDataToSetCameraPosition(id: number): { fillingPlane: Mesh; pointsMeshes: Mesh[] } | undefined {
    return (this.registry.getLayer(id) as SketchPlaneViewerLayer)?.getDataToSetCameraPosition();
  }

  getSketchLayer(id: number): ViewerSketchPlaneLayer | undefined {
    return (this.registry.getLayer(id) as SketchPlaneViewerLayer)?.layerViewer;
  }

  restoreAllSketchToolsMeshesDefault(ids: number[]): void {
    for (const id of ids) {
      (this.registry.getLayer(id) as SketchLineViewerLayer)?.restoreMeshesDefault();
    }
  }
}
